/* src/index.css — MeeChain global styles */
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Rajdhani:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');

/* ── CSS Variables ───────────────────────────────────── */
:root {
  --bg:       #07070f;
  --bg2:      #0c0c1a;
  --bg3:      #10101e;
  --bg4:      #141428;
  --border:   rgba(124,58,237,.25);
  --border2:  rgba(124,58,237,.12);
  --purple:   #7c3aed;
  --purple2:  #9d5cf5;
  --purple3:  #c084fc;
  --purple4:  #a78bfa;
  --cyan:     #06b6d4;
  --cyan2:    #67e8f9;
  --green:    #10b981;
  --green2:   #34d399;
  --amber:    #f59e0b;
  --amber2:   #fbbf24;
  --orange:   #f97316;
  --red:      #ef4444;
  --text:     #e2e0f0;
  --muted:    #6b6888;
  --muted2:   #4a4868;
  --mono:     'JetBrains Mono', monospace;
  --sans:     'Space Grotesk', sans-serif;
  --display:  'Rajdhani', sans-serif;
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html { scroll-behavior: smooth; }

body {
  background: var(--bg);
  color: var(--text);
  font-family: var(--sans);
  overflow-x: hidden;
  min-height: 100vh;
}

/* ── Background ──────────────────────────────────────── */
.bg-grid {
  position: fixed; inset: 0; z-index: 0; pointer-events: none;
  background-image:
    linear-gradient(rgba(124,58,237,.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(124,58,237,.04) 1px, transparent 1px);
  background-size: 40px 40px;
}
.bg-glow-1 {
  position: fixed; top: -200px; left: -200px; width: 700px; height: 700px;
  background: radial-gradient(circle, rgba(124,58,237,.12) 0%, transparent 65%);
  pointer-events: none; z-index: 0;
}
.bg-glow-2 {
  position: fixed; bottom: -300px; right: -100px; width: 600px; height: 600px;
  background: radial-gradient(circle, rgba(6,182,212,.07) 0%, transparent 65%);
  pointer-events: none; z-index: 0;
}

/* ── Utility ─────────────────────────────────────────── */
.hidden { display: none !important; }

/* ── Animations ──────────────────────────────────────── */
@keyframes spin {
  from { transform: translate(-50%,-50%) rotate(0deg); }
  to   { transform: translate(-50%,-50%) rotate(360deg); }
}
@keyframes float {
  0%,100% { transform: translateY(0); }
  50%      { transform: translateY(-8px); }
}
@keyframes blink {
  0%,100% { opacity: 1; }
  50%      { opacity: .4; }
}
@keyframes modal-in {
  from { transform: scale(.95); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}
@keyframes toast-in {
  from { transform: translateX(20px); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

/* ── Scrollbar ───────────────────────────────────────── */
::-webkit-scrollbar       { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: var(--bg2); }
::-webkit-scrollbar-thumb { background: rgba(124,58,237,.4); border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: rgba(124,58,237,.6); }

/* ── Responsive ──────────────────────────────────────── */
@media (max-width: 1100px) {
  section[style*="grid-template-columns: 1fr 1fr"] { grid-template-columns: 1fr !important; }
}
@media (max-width: 768px) {
  section { padding: 40px 20px !important; }
  nav     { padding: 0 16px !important; }
}
